// extracted by mini-css-extract-plugin
module.exports = {"noFeedLayout":"HomeFeedNoResults_noFeedLayout__ZjfWp","moreAppsButton":"HomeFeedNoResults_moreAppsButton__1jCEP"};